import * as React from 'react'
import { PanelDesktopProps, PanelTriggerDesktopProps, RetailNavPanelTriggerDropdownProps } from '../types'
import { Args, withArgs } from 'DVWebNodeUtils';

export const PanelDesktop = ({ panelVisible, lists, panelHooks }: PanelDesktopProps) => {
  const panelLists = lists.find((item) => item.isPanel === true)

  if(!panelLists || !panelLists.links) {
    return (null)
  }

  const panelLinks = panelLists.links.map((heading, ih) => {
    const className = heading.links.length > 20 ? 'av-panel-col av-panel-col-split-third'
      : heading.links.length > 10 ? 'av-panel-col av-panel-col-split' : 'av-panel-col'
    return (
      <div className={className} key={ih}>
        <h3>{heading.text}</h3>
        <ul className="av-panel-list">
          {heading.links.map((link, i) => (
            <li key={i} >
              <a href={link.href}
                className={link.isHighlighted
                  ? 'av-panel-item-highlight' : ''} rel={link.text}>
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      </div>)
  })

  // TODO: https://sim.amazon.com/issues/AVWebSNB-2554
  return (<React.Fragment>
    <div className={`av-panel-content ${panelVisible ? 'av-panel-visible' : 'av-panel-native'}`}
      onMouseLeave={panelHooks.makeInvisibleMouseEvent}>
      {panelLinks}
    </div>
    <div className="av-panel-overlay" onClick={() => {
      const input = document.querySelector('#av-panel-trigger-box-js') as HTMLInputElement
      if(input) {
        input.checked = !input.checked
      }
      panelHooks.toggle()
    }}></div>
  </React.Fragment>)
}

export const PanelTriggerDesktop = ({ panelHooks, label, isHighlighted }: PanelTriggerDesktopProps) => (
  <li className="av-retail-m-nav-main-item av-panel-trigger-js" key="nav-panel-trigger-js"
    onMouseEnter={panelHooks.makeVisibleMouseEvent}>
    <input type="checkbox" name="av-panel-trigger-box-js" id="av-panel-trigger-box-js"
      onChange={panelHooks.changeEvent} />
    <label className={isHighlighted
      ? 'av-retail-m-nav-highlighted' : ''} htmlFor="av-panel-trigger-box-js">
      <span className="av-retail-nav-categories-label">{label}</span>
    </label>
  </li>
)

export const PanelDropdown = ({ lists }: PanelDesktopProps) => {
  const panelLists = lists.find((item) => item.isPanel === true)

  if(!panelLists || !panelLists.links) {
    return (null)
  }

  const panelLinks = panelLists.links.map((heading) => (
    <React.Fragment>
      <h3>{heading.text}</h3>
      <ul className={heading.links.length > 10 ? 'av-panel-col-split' : ''}>
        {heading.links.map((link, i) => (
          <li key={i} >
            <a href={link.href}
              className={link.isHighlighted
                ? 'av-panel-item-highlight' : ''} rel={link.text}>
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </React.Fragment>
  ))

  return (<React.Fragment>{panelLinks}</React.Fragment>)
}

let logCategories2020OpenedMobile: NodeJS.Timeout
const PanelTriggerDropdownElement = ({ label, children, logger }: RetailNavPanelTriggerDropdownProps & Args) => (
  <li className="av-retail-m-nav-element av-retail-m-nav-main-item av-panel-trigger-css" key="nav-panel-trigger-css">
    <input type="checkbox" name={`av-panel-trigger-box-css-${label}`} id={`av-panel-trigger-box-css-${label}`}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
          event.currentTarget.checked ? logCategories2020OpenedMobile = setTimeout(() => logger.count("categories2020OpenedMobile", 1, false), 2000)
          : clearTimeout(logCategories2020OpenedMobile)}
    />
    <label htmlFor={`av-panel-trigger-box-css-${label}`} className="av-panel-trigger-box-css-label">{label}</label>
    {children}
  </li>
)
export const PanelTriggerDropdown = withArgs(PanelTriggerDropdownElement)
